/**
 * Mutable state shared between the keymap plugin (keydown handling) and the
 * main autocomplete plugin (API lifecycle + appendTransaction).
 *
 * Both plugins live in the same editor instance and run synchronously on the
 * same JS thread, so a plain object is safe — no locking required.
 *
 * A single instance is created per editor in the top-level plugin factory and
 * passed to both sub-plugins via their constructors.
 */
export interface AutoTriggerSharedState {
	/**
	 * Plain-text snapshot of the document right after the Enter-induced doc change.
	 * If further doc changes occur before the API response, we discard the
	 * suggestion instead of showing it immediately.
	 */
	postEnterPlainTextBaseline: string | null;
	/**
	 * 1-based doc line where an auto-trigger fired.
	 * Allows same-line edits during loading / suggestion_pending without
	 * dismissing the session; once the cursor moves to a lower line, further
	 * typing dismisses.
	 */
	triggerLineIndex: number | null;
	/** User pressed Enter while the auto-trigger API call is in-flight. */
	userPressedEnter: boolean;
}

export function createAutoTriggerSharedState(): AutoTriggerSharedState {
	return {
		userPressedEnter: false,
		postEnterPlainTextBaseline: null,
		triggerLineIndex: null,
	};
}
